import axios from 'axios';
import qs from 'qs'
import {httpHead,apiUrl} from './config.js';
let fetch = function (url){
	return new Promise((resolve,reject) => {
		axios.get(apiUrl + url,{
		    headers: httpHead
		})
		.then(res => {
	        resolve(res.data)
	    }).
	    catch( err => {
	    	if (err.response) {
	    		reject(err.response)
	        }
	    })
	})
}
let post = function (url,data) {
	return new Promise((resolve , reject) => {
		let postData = this.$qs.stringify(data);
		let re_url = apiUrl+url;
		axios({
			method: 'post',
		    url: re_url,
		    data:postData,
		    headers: httpHead
    	})
    	.then(res => {
            resolve(res.data);
        })
        .catch(err => {
            if (err.response) {
            	reject(err.response)
            }
        })
	})
}
export {
	fetch,
	post
}




    		
            


// WEBPACK FOOTER //
// ./src/common/util/http.js